/**
 * Filter out empty values from an object that are undefined, null, empty array or empty object
 * @param obj - The object to filter
 * @returns The filtered object
 */
export const filterEmptyValues = (obj: Record<string, unknown>) => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) =>
        value !== undefined &&
        value !== null &&
        (!Array.isArray(value) || value.length > 0) &&
        (typeof value !== 'object' || Object.keys(value).length > 0),
    ),
  );
};
